import Label from './Label.component';

export default Label;
